var exports = {
  "S": "x127c5a35--dd8d14--image",
};

module.exports = exports;
